import Brazil from './brazil.vue'
import Cambodia from './cambodia.vue'
import China from './china.vue'
import Indonesia from './indonesia.vue'
import International from './international.vue'
import Japan from './japan.vue'
import Korea from './korea.vue'
import Malaysia from './malaysia.vue'
import ROA from './roa.vue'
import ROE from './roe.vue'
import Thailand from './thailand.vue'
import UK from './uk.vue'
import Vietnam from './vietnam.vue'

const flags = {
  // Key based on country / region code
  br: { component: Brazil },
  kh: { component: Cambodia },
  cn: { component: China },
  id: { component: Indonesia },
  row: { component: International },
  jp: { component: Japan },
  kr: { component: Korea },
  my: { component: Malaysia },
  roa: { component: ROA },
  roe: { component: ROE },
  th: { component: Thailand },
  uk: { component: UK },
  vn: { component: Vietnam },
}

export default flags